import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

/**
 * @description: This component simply provides a bordered container and has an optional header component app-panel-header
 * Additionally, the appCollapsiblePanel directive should be used to make this panel collapsible.
 *
 * @notes: see PanelHeaderComponent and CollapsiblePanelDirective for additional examples.
 *
 * @example: w/Out app-panel-header Component
 * <app-panel>
 *   Some content <span> more content</span>
 * </app-panel>
 *
 * @example: With app-panel-header Component
 * <app-panel>
 *   <app-panel-header>My Header<app-panel-header>
 *   Some content <span> more content</span>
 * </app-panel>
 *
 * @example: With appCollapsiblePanel Directive
 * <app-panel appCollapsiblePanel>
 *   <app-panel-header>My Header<app-panel-header>
 *   Some content <span> more content</span>
 * </app-panel>
 */
@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [],
    standalone: false
})
export class PanelComponent {
  @Input() isCollapsed = false;
}
